import { SummationGroups } from "./summation-groups.component";
import { SummationGroup } from "./summation-group.component";
import { SummationGroupMappings } from "./summation-group-mappings.component";
import { EditSummationGroup } from "./summation-group.edit.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { summationGroupsState, summationGroupState, newSummationGroupState, editSummationGroupState } from "./summation-groups.states";
import { AllMaterialModule } from "../../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";

import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";

let SUMMATION_GROUP_STATES = [summationGroupsState, summationGroupState, newSummationGroupState, editSummationGroupState];

import { ConfirmDialog } from "../../shared/confirm-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: SUMMATION_GROUP_STATES })
    ],
    declarations: [SummationGroups, SummationGroup, EditSummationGroup, SummationGroupMappings],
    entryComponents: [ConfirmDialog]
})
export class SummationGroupsModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/summationgroups/summation-groups.module.ts